import 'reflect-metadata';
import { jsonObject, jsonMember, toJson, TypedJSON } from 'typedjson';

@jsonObject
@toJson
export class TemperatureLevel {
  @jsonMember(Number)
  public temperature!: number;

  // L’API renvoie une string ISO -> on map directement en Date
  @jsonMember(Date)
  public date!: Date;
}

export const serializer = new TypedJSON(TemperatureLevel);
